import { 
    Text,
    Grid,
    useTheme
} from '@nextui-org/react'
import { useLocation, useNavigate } from 'react-router-dom'
import { Link } from '@nextui-org/react'

import { Navbar } from '@nextui-org/react'

import HeaderText from '../../ui/header'
import {Content} from '../../ui/layout/content'
import { Box } from '../../ui/layout/box'
import Button from '../../ui/button'
import MenuBar from '../../ui/menuBar'
import Features from './features'
import Story from '../story'
import ForStartUp from '../story/startup'
import HowItWorks from '../howItWorks'

export const Header = () => {
    const location = useLocation()
    const navigate = useNavigate()
    const {theme} = useTheme()

    const collapseItems = [
        // {name: "About", href: "/about"},
        {name: "How It Works", href: "#how-it-works"},
        {name: "Opportunities", href: "/opportunities"},
        {name: "Services", href: "#services"}
    ]

    // TODO - use location.pathname to control height of the header
    return (
        <>
            <Content 
                contentCss={{
                    marginTop: 0,
                    minHeight: location.pathname === '/' ? "300px" : "100px"
                }}>
                    <Grid.Container 
                        id="grid_container"
                        css={{height: "100%"}}
                        gap={1} 
                        justify="flex-start">
                        <Grid xs={12} >
                            <Navbar 
                                disableShadow
                                disableBlur
                                css={{
                                    $$navbarBackgroundColor: "transparent",
                                    marginBottom: 0
                            }}>
                                <Navbar.Content css={{
                                    // alignItems: location.pathname === '/' ? "flex-start" : "center"
                                    alignItems: "center"
                                }}>
                                    <Navbar.Toggle 
                                        aria-label="toggle navigation" 
                                        showIn="sm"/>
                                    <Navbar.Brand css={{
                                        fontFamily: ["Garet Heavy"].join(','),
                                        letterSpacing: "$tighter",
                                        // marginTop: location.pathname === '/' ? "5px" : 0
                                    }}>
                                        <Text size="$xl" b color='$primary'>
                                            Li<Text as="span" size="$xl" b color="$secondary">i</Text>nkage
                                        </Text>
                                    </Navbar.Brand>
                                </Navbar.Content>
                                <Navbar.Content 
                                    hideIn="sm"
                                    css={{
                                        alignItems: "center"
                                    }}>
                                    {
                                        location.pathname === '/' && <MenuBar />
                                    }
                                </Navbar.Content>
                                <Navbar.Collapse>
                                    {
                                        location.pathname === '/' &&   
                                        collapseItems.map((item, index) => (
                                            <Navbar.CollapseItem 
                                                key={item.name.toLowerCase()}
                                                onClick={() => {
                                                    // HACK
                                                    document.querySelector('button.nextui-navbar-toggle').click()
                                                    document.querySelector('button.nextui-navbar-toggle').click()
                                                    document.querySelector('button.nextui-navbar-toggle').click()
                                                    if (item.href.indexOf('#') >= 0) {
                                                        document.querySelector(item.href).scrollIntoView({behavior: "smooth"})                                                        
                                                    } else {
                                                        navigate(item.href)
                                                    }
                                                }}>
                                                <Text b color="primary">
                                                    {item.name}
                                                </Text>
                                            </Navbar.CollapseItem>
                                        ))
                                    }
                                    {
                                        location.pathname !== '/' &&
                                        <Navbar.CollapseItem 
                                            onClick={() => {
                                                // HACK
                                                document.querySelector('button.nextui-navbar-toggle').click()
                                                document.querySelector('button.nextui-navbar-toggle').click()
                                                document.querySelector('button.nextui-navbar-toggle').click()
                                                navigate('/')
                                            }}>
                                            <Text b color="primary">
                                                Home
                                            </Text>
                                        </Navbar.CollapseItem>
                                    }
                                </Navbar.Collapse>
                            </Navbar>
                        </Grid>
                        {
                            location.pathname === '/' &&
                            // <Grid xs={12}>
                            //     <Grid.Container>
                            //         <Grid xs={12} md={6} css={{flexDirection: "column", justifyContent: "space-around"}}>
                            //             <div>
                            //                 <HeaderText tighten heavy value="Foster and Strengthen Collaboration" h1 />
                            //                 <HeaderText tighten heavy value="Support and Accelerate Innovation" h1 marginTop="10px" />
                            //             </div>
                            //             <div>
                            //                 <Button text="See How It Works"/>
                            //             </div>
                            //         </Grid>
                            //         <Grid xs={12} md={6} css={{flexDirection: "column"}}>
                            //             <Story />
                            //         </Grid>
                            //     </Grid.Container>
                            // </Grid>
                            <>
                                <Grid xs={12} justify="center">
                                    <Box css={{mt: "50px"}}>
                                        <HeaderText centered  heavy value="Foster and Strengthen Collaboration" h1 />
                                        <HeaderText centered  heavy value="Support and Accelerate Innovation" h1 marginTop="10px" />
                                    </Box>
                                </Grid>
                                {/* <Grid xs={12} justify="center">
                                    <Box css={{mt: "50px"}}>
                                        <Button 
                                            text="See What We Do"
                                            onClick={() => {
                                                document.querySelector('#services').scrollIntoView({behavior: "smooth"})
                                            }}/>
                                    </Box>
                                </Grid> */}
                            </>
                        }
                        {/* <Box css={{
                            '@mdMax': {
                                display: 'none'
                            },
                            '@mdMin': {
                                right: "100px",
                                position: "absolute",
                                width: "400px",
                                top: "100px"
                            }
                        }}>
                            <img src={heroImg}/>
                        </Box> */}
                    </Grid.Container>
            </Content>
        </>
    )
}

export const Home = () => {
    return (
        <>
            <Features />
            <Story />
            <ForStartUp />
            <HowItWorks />
        </>
    )
}